import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-baseline gap-x1" }
const _hoisted_2 = { class: "flex flex-wrap items-center gap-x2" }
const _hoisted_3 = { class: "-mt-3 font-cormorant text-16 md:text-18 xl:text-22" }
const _hoisted_4 = { class: "text-13 line-through" }
const _hoisted_5 = { class: "text-13" }

import { ProductDiscountType, ProductPriceModel } from '@/types/productServerApi';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import { computed } from 'vue';
import dictionaryService from '@/core/dictionary/dictionary.service';
import ProductNetPrice from '@/b2b/product/ui/ProductNetPrice.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultMaterialPrice',
  props: {
    price: null,
    variantId: null
  },
  setup(__props: any) {

const props = __props as {
    price: ProductPriceModel;
    variantId: string;
}



const globalLabels = useGlobalLabels(GlobalLabels.product);

const formattedDiscountLabel = computed(() => {
    if (!props.price.discount) {
        return '';
    }
    const label = props.price.discount.type === ProductDiscountType.MyBoliaBoost
        ? globalLabels.myBoliaDiscount
        : globalLabels.discount;
    return dictionaryService.formatNamed(label, { discount: props.price.discount.percentage });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.price.salesPrice.amount), 1),
      (__props.price.discount?.discount)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.price.listPrice.amount), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formattedDiscountLabel)), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ProductNetPrice, { "variant-id": __props.variantId }, null, 8, ["variant-id"])
  ]))
}
}

})